import React from "react";
import { themeFor } from "../utils/theme";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { CookieBanner } from "./CookieBanner";
import { StickyBar } from "./StickyBar";

// Gabarit commun : en-tête, contenu, pied de page, barre d'appel et bandeau cookies.
export function Layout({ provider, children }) {
  return (
    <div className="page" style={themeFor(provider)}>
      <Header />
      <main>{children}</main>
      <Footer />
      <CookieBanner />
      <StickyBar />
    </div>
  );
}
